function emptyValueAnnouncer(value, componentName) {
  if (value.trim() !== "") {
    return;
  }
  console.error(
    `[${componentName}] Option\uC758 value\uB85C \uBE48 \uAC12\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC758\uB3C4\uB41C \uC0C1\uD669\uC778\uC9C0 \uB2E4\uC2DC \uD655\uC778\uD574 \uC8FC\uC138\uC694.`
  );
}

export { emptyValueAnnouncer };
//# sourceMappingURL=empty-value-announcer.mjs.map
